import { default as ApiConfig } from 'config';
import { format, utcToZonedTime } from 'date-fns-tz';

const rfc7231ToCalendarFormat = (time: number, timeZone?: string) =>
    format(utcToZonedTime(time, timeZone), "yyyyMMdd'T'HHmmss"); // with no timezone, convert to local timezone

type GetAddToCalendarUrl = (params: {
    type: string;
    timeZone?: string;
    startDateUTCTimestamp?: number;
    endDateUTCTimestamp?: number;
    location?: string;
    title?: string;
    description?: string;
    detailsUrl?: string;
}) => string;

export const getAddToCalendarUrl: GetAddToCalendarUrl = ({
    timeZone,
    startDateUTCTimestamp = 0,
    endDateUTCTimestamp = 0,
    location = '',
    title = '',
    description = '',
    detailsUrl = '',
    type,
}) => {
    let calendarUrl = '';

    const startDateFormatted = rfc7231ToCalendarFormat(startDateUTCTimestamp, timeZone);
    const endDateFormatted = rfc7231ToCalendarFormat(endDateUTCTimestamp, timeZone);

    switch (type) {
        case 'google': {
            calendarUrl = 'https://calendar.google.com/calendar/render';
            calendarUrl += '?action=TEMPLATE';
            calendarUrl += '&dates=' + startDateFormatted;
            calendarUrl += '/' + endDateFormatted;
            calendarUrl += '&location=' + encodeURIComponent(location);
            calendarUrl += '&text=' + encodeURIComponent(title);
            calendarUrl +=
                '&details=' +
                encodeURIComponent(description + (detailsUrl ? '\n\n' + detailsUrl : ''));
            break;
        }

        default: {
            const urlDetailsEnd = detailsUrl ? '\\n\\n' + detailsUrl : '';
            calendarUrl = [
                'BEGIN:VCALENDAR',
                'VERSION:2.0',
                'BEGIN:VEVENT',
                'DTSTART:' + startDateFormatted,
                'DTEND:' + endDateFormatted,
                'SUMMARY:' + title,
                'DESCRIPTION:' + description.replace(/(\r\n|\n|\r)/gm, '\\n') + urlDetailsEnd,
                'LOCATION:' + location,
                'END:VEVENT',
                'END:VCALENDAR',
            ].join('\n');

            // TODO: stop using the old Agenda service (download/ical)
            calendarUrl = `${ApiConfig.eventsUrl}/download/ical?data=${encodeURIComponent(
                calendarUrl
            )}`;
            break;
        }
    }

    return calendarUrl;
};
